// src/pages/private/settings/Security.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import SecurityCredential from './securityTabs/SecurityCredential';
import SecurityMfa from './securityTabs/SecurityMfa';
import SecuritySessions from './securityTabs/SecuritySessions';
import MobileLogin from './securityTabs/MobileLogin';
import AccountDeletion from './securityTabs/AccountDeletion';

function Security() {
  const { t } = useTranslation();

  return (
    <div
      className="user-settings-container security-page"
      data-resource="private.settings.security"
      data-action="read"
    >
      <h2 className="settings-h2">
        {t('SecuritySettingsTitle')}
      </h2>

      <SecurityCredential />

      <SecuritySessions />

      <MobileLogin />

      <SecurityMfa />

      <AccountDeletion />

      <div className="last-line" />
    </div>
  );
}

export default Security;
